import ng from 'angular'
import ngSanitize from 'angular-sanitize'

import uiRouter from '@uirouter/angularjs/lib-esm'

import slotTrakUtils from '../utils/index'
import slotTrakUi from '../ui/index'

var deps = [
  uiRouter,
  'angularGrid',
  slotTrakUtils,
  ngSanitize,
  slotTrakUi
]

var mod = ng.module('SlotTrak.Properties', deps)

export default mod.name


